'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiWiFi = function TiWiFi(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.4 32.4c1.3-1.3 1.3-3.5 0-4.8-1.3-1.3-3.5-1.3-4.8 0-1.3 1.3-1.3 3.5 0 4.8 1.3 1.3 3.5 1.3 4.8 0z m11.7-13.2c-0.8 0-1.7-0.3-2.3-1-6.5-6.5-17.1-6.5-23.6 0-1.3 1.3-3.4 1.3-4.7 0-1.3-1.3-1.3-3.4 0-4.7 9.1-9.1 23.9-9.1 33 0 1.3 1.3 1.3 3.4 0 4.7-0.7 0.7-1.5 1-2.4 1z m-21.2 7.1c-0.8 0-1.7-0.4-2.3-1-1.3-1.3-1.3-3.4 0-4.7 5.2-5.2 13.6-5.2 18.8 0 1.3 1.3 1.3 3.4 0 4.7-1.3 1.3-3.4 1.3-4.7 0-2.6-2.6-6.8-2.6-9.4 0-0.7 0.6-1.5 1-2.4 1z' })
        )
    );
};

exports.default = TiWiFi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/wi-fi.js
// module id = 3839
// module chunks = 0